// Mirrors _features/invoices/state/slice.js's shape (selectedFilters +
// customColumns, REHYDRATE normalization) - does NOT carry forward the old
// plain `features/payment/paymentslice.js`'s `payments`/`totalPrice`
// mirroring (dead-sync pattern already dropped for every other feature
// migrated this session).
//
// Separate Redux key (`paymentsFeature`, plural) from the legacy `payments`
// slice (singular) - that old slice stays registered for its own remaining
// consumers (Razorpay/Stripe credentials, read by Integrations/checkout
// components), see docs/known-issues.md.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  selectedFilters: {
    sort: "-createdAt",
  },
};

const paymentsFeatureSlice = createSlice({
  name: "paymentsFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.paymentsFeature) {
        const persistedData = action.payload.paymentsFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...persistedData.selectedFilters,
            sort: persistedSort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } =
  paymentsFeatureSlice.actions;

export default paymentsFeatureSlice.reducer;
